import React, { useEffect, useCallback, useState, useMemo } from 'react'
import { createPortal } from 'react-dom'
import { Field, useField, useFormikContext } from 'formik'
import Popup from 'devextreme-react/popup'
import Button from 'devextreme-react/button'
import ScrollView from 'devextreme-react/scroll-view'
// import { useField, useFormikContext } from 'formik'

export const IxField = ({ onContentReady, groupId, ...props }: any) => {
    const { name, readOnly, readOnlyReset, visibleReset } = props
    const { setFieldValue } = useFormikContext()
    const [, { initialValue }] = useField<any>({ name: props.name })
    const [divRef, setDivRef] = useState<any>(null)
    const [isConnected, setIsConnected] = useState(false)

    const setRef = useCallback((element: any) => { setDivRef(element) }, [])
    useEffect(() => { divRef && setIsConnected(divRef.isConnected) }, [divRef])

    useEffect(() => {
        onContentReady && onContentReady(groupId, props.name)
    }, [onContentReady, groupId, props.name])

    useEffect(() => {
        if (visibleReset === 'e' || visibleReset === 'b') {
            // reset
            setFieldValue(name, initialValue, false)
        }

        if (visibleReset === 'd' || visibleReset === 'b') {
            return () => {
                setFieldValue(name, initialValue, false)
            }
        }
    }, [visibleReset, initialValue, setFieldValue, name])

    useEffect(() => {
        if ((readOnly && readOnlyReset === 'd') || (!readOnly && readOnlyReset === 'e') || readOnlyReset === 'b') {
            setFieldValue(name, initialValue, true)
        }
    }, [readOnly, initialValue, name, setFieldValue, readOnlyReset])

    return (
        <div ref={ setRef } style={ { width: '100%' } }>
            { isConnected && <Field { ...props } /> }
        </div>
    )
}

export const IxEmptyField = ({ onContentReady, groupId, name }: any) => {
    useEffect(() => {
        onContentReady && onContentReady(groupId, name)
    }, [onContentReady, groupId, name])

    return null
}

export const IxFormField = ({ onContentReady, groupId, ...props }: any) => {
    const { name, showSubForm, hideSubForm, portalId } = props
    const { setFieldValue } = useFormikContext()
    const [open, setOpen] = useState(false)
    const [{ value }] = useField<any>({ name: props.name })

    const portalElement = useMemo(() => portalId ? document.getElementById(portalId) : null, [portalId])

    useEffect(() => {
        onContentReady && onContentReady(groupId, props.name)
    }, [onContentReady, groupId, props.name])

    const onSubmit = useCallback(() => {
        setOpen(false)
        hideSubForm()
    }, [hideSubForm])

    const onValueChanged = useCallback((values: any) => {
        setFieldValue(name, values)
    }, [name, setFieldValue])

    const onClick = useCallback(() => {
        setOpen(true)
        setTimeout(showSubForm, 0)
    }, [showSubForm])

    return (
        <div className='rb-item mb-1'>
            <Button onClick={ onClick } text={ props.label } />
            {
                portalId ? (
                    open && portalElement && createPortal(
                        <Field
                            { ...props }
                            active={ true }
                            loadingEnabled={ true }
                            asField={ true }
                            formType='field'
                            onSubmit={ onSubmit }
                            value={ value }
                            onValueChanged={ onValueChanged }
                        />,
                        portalElement
                    )
                ) : (
                    <Popup
                        visible={ open }
                        onHiding={ () => setOpen(false) }
                        showCloseButton={ true }
                    >
                        <ScrollView height='100%' width='100%'>
                            <div>
                                <Field
                                    { ...props }
                                    active={ true }
                                    asField={ true }
                                    formType='field'
                                    onSubmit={ onSubmit }
                                    value={ value }
                                    onValueChanged={ onValueChanged }
                                />
                            </div>
                        </ScrollView>
                    </Popup>
                )
            }
        </div>
    )
}
